import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from "../../../services/notification.service";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: 'notification-list',
  templateUrl: 'notification-list.html'
})

export class NotificationList  implements OnInit, OnDestroy {

	@Input() isDropdown?: boolean = false;
  private onNotificationUpdateSubscriptions: Subscription[] = [];


  constructor(public notificationService: NotificationService,
              private changeDetector: ChangeDetectorRef,) {
		
  }
  
  ngOnInit(): void {
    this.onNotificationUpdateSubscriptions.push(this.notificationService.onLoad.subscribe(()=>{
      this.changeDetector.detectChanges();
    }));
    this.onNotificationUpdateSubscriptions.push(this.notificationService.onPrepend.subscribe(()=>{
      this.changeDetector.detectChanges();
    }));
    this.onNotificationUpdateSubscriptions.push(this.notificationService.onAppend.subscribe(()=>{
      this.changeDetector.detectChanges();
    }));
    
  }

  ngOnDestroy(): void {
    if(this.onNotificationUpdateSubscriptions.length) {
      this.onNotificationUpdateSubscriptions.forEach((subscription: Subscription) => {
        subscription.unsubscribe();
      });
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/partials/notification/notification-list/notification-list.ts